import { AxiosInstance } from 'axios';
import { formDataInputs } from '@/tools/formdatainputs';
import {
  mapRooms,
  mapLessons,
  mapTests,
  mapExaminationList,
  mapExaminationItem,
  mapExaminationItemResult,
} from './utils';
import {
  RoomsResponseType,
  RemoteEduPoints,
  LessonsResponseType,
  ExaminationsResponseType,
  ExaminationResponseType,
  ExaminationResultResponseType,
} from './types';

const getRemoteEduRoomsData = (api: AxiosInstance) => ({
  getRemoteEduRooms: async (kidId: string) => {
    const { data } = await api.get<RoomsResponseType>(
      RemoteEduPoints.GET_ROOMS + kidId
    );
    return { ...data, data: mapRooms(data.data) };
  },
});
const getSferumWebinarsData = (api: AxiosInstance) => ({
  getSferumWebinars: async (kidId: string, page = 1) => {
    const { data } = await api.get<any>(
      RemoteEduPoints.GET_SFERUM_WEBINARS + kidId,
      {
        params: {
          page,
          limit: 10,
        },
      }
    );
    return { data };
  },
});

const getRemoteEduLessonsData = (api: AxiosInstance) => ({
  getRemoteEduLessons: async (kidId: string) => {
    const { data } = await api.get<LessonsResponseType>(
      RemoteEduPoints.GET_LESSONS + kidId
    );
    return { ...data, data: mapLessons(data.data) };
  },
});

const getRemoteEduTestsData = (api: AxiosInstance) => ({
  getRemoteEduTests: async (kidId: string) => {
    const { data } = await api.get<LessonsResponseType>(
      RemoteEduPoints.GET_TESTS + kidId
    );
    return { ...data, data: mapTests(data.data) };
  },
});

const postRemoteEduTestsData = (api: AxiosInstance) => ({
  postRemoteEduTests: async (payload: any): Promise<any> => {
    const formData = formDataInputs(payload);
    const { data } = await api.post(RemoteEduPoints.POST_TESTS, formData);
    return data;
  },
});

const postRemoteEduExaminationItemData = (api: AxiosInstance) => ({
  postRemoteEduExaminationItem: async (payload: any): Promise<any> => {
    const { data } = await api.post(
      RemoteEduPoints.POST_EXAMINATION_ITEM,
      payload
    );
    return data;
  },
});

const getRemoteEduExaminationListData = (api: AxiosInstance) => ({
  getRemoteEduExaminationList: async () => {
    const { data } = await api.get<ExaminationsResponseType>(
      RemoteEduPoints.GET_EXAMINATION_LIST
    );
    return { ...data, data: mapExaminationList(data.data) };
  },
});

const getRemoteEduExaminationItemData = (api: AxiosInstance) => ({
  getRemoteEduExaminationItem: async (id: string, groupId: string) => {
    const { data } = await api.get<ExaminationResponseType>(
      `${RemoteEduPoints.GET_EXAMINATION_ITEM}/${id}/${groupId}`
    );
    return { ...data, data: mapExaminationItem(data.data) };
  },
});

const getRemoteEduExaminationItemResultData = (api: AxiosInstance) => ({
  getRemoteEduExaminationItemResult: async (id: string) => {
    const { data } = await api.get<ExaminationResultResponseType>(
      `${RemoteEduPoints.GET_EXAMINATION_ITEM_RESULT}/${id}`
    );
    return { ...data, data: mapExaminationItemResult(data.data) };
  },
});

export const remoteEduService = (api: AxiosInstance) => {
  if (!api) throw new Error('There is no HTTP client');
  return {
    ...getSferumWebinarsData(api),
    ...getRemoteEduRoomsData(api),
    ...getRemoteEduLessonsData(api),
    ...getRemoteEduTestsData(api),
    ...postRemoteEduExaminationItemData(api),
    ...getRemoteEduExaminationListData(api),
    ...getRemoteEduExaminationItemData(api),
    ...getRemoteEduExaminationItemResultData(api),
    ...postRemoteEduTestsData(api),
  };
};



// WEBPACK FOOTER //
// ./src/services/api/remoteedu/remoteEduService.ts